import React, { useEffect, useState } from 'react'

import PartialTextWithIcon from './partials/twb_text_with_icon'
import PartialText from './partials/twb_text'
import PartialFeatures from './partials/twb_features'
import PartialCTA from './partials/twb_cta'
import { ToggleFilter } from './pops/pops_map'
import { getCompleteStyleManualPositioning } from '~/utils/helpers'
import { useViewport } from '~/utils/viewport-provider'
import { ComingSoon } from './tabs'

const FourSquares = ({ block, type }) => {
  const hasSquareGroups = type === "filter" && block.group && block.group.length > 0;
  const [squares, setSquares] = useState(hasSquareGroups ? [...block.group[0].squares] : [...block.squares])
  const [filter, setFilter] = useState(hasSquareGroups ? block.group[0].label : null);
  const columnsClass = type !== "horizontal" ? "col-lg-6 col-md-12" : "";
  const squaresType = hasSquareGroups ? "squares--groups" : `squares--${type}`;
  if (block.position === 'Left') {
    block.position_class = ' pos-left'
  }
  else {
    block.position_class = ' pos-right'
  }

  useEffect(() => {
    if (!hasSquareGroups) {
      return;
    }

    const group = block.group.find((item) => item.label === filter);
    if (group) {
      setSquares([...group.squares]);
    }
  }, [filter]);

  return (
    <section className={`block block__four_square  ${block.css_class_name} ${block.position_class}`}>
      <div className="container">
        <div className="row">
          {columnsClass !== "" ? <div className={`${columnsClass} text`}>
            <LeftColumnContent block={block} hasSquareGroups={hasSquareGroups} />
          </div> : null}

          <div className={`squares ${columnsClass} ${squaresType}`}>
            <div className="row">
              {squares.map((square, index) => {
                return <Square key={index} square={square} cols={columnsClass !== "" ? "col-md-6" : "col-md-4"} />
              })}
            </div>
            {hasSquareGroups && (
              <div className="squares__filter">
                <ToggleFilter
                  items={block.group}
                  updateFilter={(idx) => setFilter(block.group[idx].label)}
                  color="blue"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

const LeftColumnContent = ({ block, hasSquareGroups }) => {
  const { isMobile } = useViewport();
  if (hasSquareGroups && block.image) {
    return (
      <img src={block.image} alt={block.image_alt_text} />
    )
  }

  if (block.image) {
    let { mobile, desktop } = getCompleteStyleManualPositioning(block.manual_positioning);

    return (
      <div className='content'>
        <img
          src={block.image}
          alt={block.image_alt_text}
          title={block.image_alt_text}
          style={isMobile ? mobile : desktop}
        />
      </div>
    )
  }

  return (<>

    {block.title && <h3 dangerouslySetInnerHTML={{ __html: block.title }}></h3>}
    {block.subtitle && <div className="text-formatted" dangerouslySetInnerHTML={{ __html: block.subtitle }}></div>}
    {block.text_with_blocks && (
      block.text_with_blocks.map((twb, index) => {
        const nested = twb.blocks.map((block, index) => {
          switch (block._template) {
            case 'partial__text':
              return <PartialText key={index} block={block} />
            case 'partial__text_with_icon':
              return <PartialTextWithIcon key={index} block={block} />
            case 'partial__features':
              return <PartialFeatures key={index} block={block} />
            case 'partial__cta':
              return <PartialCTA key={index} block={block} />
            default:
              return 'Missing block.'
          }
        })
        return <React.Fragment key={index}>{nested}</React.Fragment>
      })
    )}
  </>)
}

const Square = ({ square, cols }) => {
  return (
    <div className={`square ${cols}`}>
      <div className="card">
        <div className="hover">
          <span className="circle blue"></span>
          <span className="circle orange"></span>
        </div>
        {square.style && (
          <ComingSoon style={square.style} override='four-squares' />
        )}
        <div className="content-wr">
          {square.icon && (
            <img src={square.icon} alt={square.title} title={square.title} />
          )}
          {square.title && (
            <h4 dangerouslySetInnerHTML={{ __html: square.title }}></h4>
          )}
          {square.text && (
            <p dangerouslySetInnerHTML={{ __html: square.text }}></p>
          )}
        </div>
      </div>
    </div>
  )
}

export default FourSquares;